/**
 * Constrói um conjunto ENXUTO e sem PII de propriedades para um evento de erro
 * espelhado no PostHog, a partir do `extraData`/erro já usados no Rollbar.
 *
 * Regra: nunca enviar corpos de request/response, dados de cartão, e-mail, CPF,
 * nome ou qualquer payload bruto — apenas escalares seguros úteis para funis e
 * dashboards de saúde (nome do erro, status HTTP, contexto, ids de negócio).
 */
export function buildErrorEventProps(
  extraData: Record<string, unknown> = {},
  error: unknown = {}
): Record<string, unknown> {
  const e = (error ?? {}) as {
    name?: string;
    message?: unknown;
    isAxiosError?: boolean;
    response?: { status?: number };
    constructor?: { name?: string };
  };
  const x = (extraData ?? {}) as Record<string, unknown>;

  const status = (x.status as number | undefined) ?? e.response?.status;
  const message = typeof e.message === 'string' ? e.message.slice(0, 300) : undefined;

  const props: Record<string, unknown> = {
    level: 'error',
    error_name: e.name,
    error_message: message,
    error_type: e.isAxiosError ? 'axios' : e.constructor?.name || typeof error,
    status,
    context: x.context,
    // ids de negócio (não são PII) úteis para correlacionar no PostHog
    plan_id: x.planId ?? x.planParam,
    contract_id: x.contractId,
    quote_hash: x.quoteHash,
    product_id: x.productId
  };

  // remove chaves undefined para não poluir o evento
  Object.keys(props).forEach((k) => props[k] === undefined && delete props[k]);
  return props;
}
